/** 违禁词库 API 封装，共享契约定义输入和响应；页面通过 Query 管理状态。 */
import type {
  ProhibitedTermDto,
  ProhibitedTermInput,
  ProhibitedTermsPage,
} from '@novel-admin/shared';
import { apiRequest } from '~/api/client';
export const prohibitedTermsApi = {
  list: (query: {
    q?: string;
    language?: string;
    enabled?: string;
    offset: number;
    limit: number;
  }) => apiRequest<ProhibitedTermsPage>({ method: 'GET', path: '/api/v1/prohibited-terms', query }),
  create: (body: ProhibitedTermInput) =>
    apiRequest<ProhibitedTermDto>({ method: 'POST', path: '/api/v1/prohibited-terms', body }),
  update: (id: string, body: ProhibitedTermInput) =>
    apiRequest<ProhibitedTermDto>({ method: 'PUT', path: `/api/v1/prohibited-terms/${id}`, body }),
  remove: (id: string) =>
    apiRequest<{ deleted: true }>({ method: 'DELETE', path: `/api/v1/prohibited-terms/${id}` }),
  import: (items: ProhibitedTermInput[]) =>
    apiRequest<{ imported: number; skipped: number }>({
      method: 'POST',
      path: '/api/v1/prohibited-terms/import',
      body: { items },
    }),
};
